import { useEffect, useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getQuestionnairesOverall } from './GeneralRisk.services';

interface campaignIdProps {
	campaignId: string;
}

const useGeneralRisk = ({ campaignId }: campaignIdProps) => {
	const [data, setData] = useState<any>([]);
	const [isLoading, setLoading] = useState(false);

	const fetchData = async () => {
		setLoading(true);
		try {
			const { data: dataQuestionnaires } = await getQuestionnairesOverall(
				campaignId,
			);

			setData(dataQuestionnaires.content);
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'questionnairesOverall',
				payloadRequest: { campaignId },
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId]);

	return {
		data,
		isLoading,
	};
};

export default useGeneralRisk;
